module.exports = __webpack_public_path__ + "img/121.ef9ebf52.png";